module.exports = __webpack_public_path__ + "static/media/far2con2.2256eb8b.png";